import { httpGet } from '../../../../common/util'

export const loginFor9891 = () => {
    return httpGet({
        url: '/user/login/neno/quietLogin',
        auth: true
    })
}